import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import LegacyFormHelper from "@Scripts/Infrastructure/LegacyFormHelper";

@Component({ name: "NewsletterUnsubscribe" })
export default class NewsletterUnsubscribe extends Vue {
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public newsletterUnsubscribeSubmit: any = { email: '' };
    public validationErrors: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    public async setNewsletterUnsubscribeSubmit() {
        this.validationErrors = [];
        this.isLoading = true;

        try {
            await Axios.post(this.routes.Newsletter_NewsletterUnsubscribe, this.newsletterUnsubscribeSubmit);

            this.isSuccess = true;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = LegacyFormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public isValidationError(controlName: string): boolean {
        return LegacyFormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};